/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Status_Pending_AuthorizationInputs */

const en_inbound_status_pending_authorization = /** @type {(inputs: Inbound_Status_Pending_AuthorizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To authorize`)
};

/**
* | output |
* | --- |
* | "To authorize" |
*
* @param {Inbound_Status_Pending_AuthorizationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_status_pending_authorization = /** @type {((inputs?: Inbound_Status_Pending_AuthorizationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Status_Pending_AuthorizationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_status_pending_authorization(inputs)
});